import React from "react";
import { Navigate } from "react-router";
import useAuthValue from "../modules/authModule/hooks/useAuthValue";
import { ROUTE_NAME } from "./types/CommonTypes";

interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isLoggedIn } = useAuthValue();
  return !isLoggedIn ? children : <Navigate to={"/" + ROUTE_NAME.ROOT} />;
};

export default ProtectedRoute;
